import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'sugar-design';

import styles from './FormNav.cm.styl';

const OFFSET_LEFT = 700;

class FormNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeNavIndex: 0,
    };
    this.clickActived = false;
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.computePosition = this.computePosition.bind(this);
    this.ref = (node) => (this.navNode = node);
  }

  componentDidMount() {
    const { scrollTargetSelector } = this.props;
    const scrollTarget = scrollTargetSelector
      ? document.querySelector(scrollTargetSelector)
      : window;
    scrollTarget.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
    window.addEventListener('load', this.computePosition);
  }

  componentWillUnmount() {
    const { scrollTargetSelector } = this.props;
    const scrollTarget = scrollTargetSelector
      ? document.querySelector(scrollTargetSelector)
      : window;
    scrollTarget.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('load', this.computePosition);
  }

  onScroll() {
    this.computePosition();
    // 点击导航栏，由于javascript设置scrollTop,会触发一次onScroll，这里判断一下。
    // 不要使用event.isTrusted，因为它一直都是true，不靠谱
    if (this.clickActived) {
      this.clickActived = false;
      return;
    }
    this.setActiveNav();
  }

  onResize() {
    this.computePosition();
    this.setActiveNav();
  }

  computePosition() {
    const { formSelector, offsetTop, fixTop } = this.props;
    if (!this.navNode) {
      return;
    }
    const { left, top } = document.querySelector(formSelector).getBoundingClientRect();
    if (top <= offsetTop) {
      this.navNode.classList.add('fixed');
      this.navNode.style.left = `${left + OFFSET_LEFT}px`;
      this.navNode.style.top = `${fixTop}px`;
    } else {
      this.navNode.classList.remove('fixed');
      this.navNode.style.left = `${OFFSET_LEFT}px`;
      this.navNode.style.top = '32px';
    }
  }

  setActiveNav() {
    const { navs, offsetTop } = this.props;
    const activeNav = navs.find((nav) => {
      const navContainer = document.querySelector(nav.selector);
      if (!navContainer) {
        return false;
      }
      const { top, height } = navContainer.getBoundingClientRect();
      if (top <= offsetTop && top + height > offsetTop) {
        return true;
      }
    });
    const activeNavIndex = activeNav ? navs.indexOf(activeNav) : 0;
    if (activeNavIndex !== this.state.activeNavIndex) {
      this.setState({ activeNavIndex });
    }
  }

  scrollIntoView(node) {
    const { offsetTop, scrollTargetSelector } = this.props;
    const scrollTarget = document.querySelector(scrollTargetSelector);
    const scrollTop = this.getScrollTop();
    const { top } = node.getBoundingClientRect();
    const newScrollTop = scrollTop + top - offsetTop;
    if (scrollTarget) {
      scrollTarget.scrollTop = newScrollTop;
    } else {
      document.body.scrollTop = newScrollTop;
      document.documentElement.scrollTop = newScrollTop;
      window.scrollTo(0, newScrollTop);
    }
  }

  getBodyScrollTop() {
    // 确保兼容性
    return document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
  }

  getScrollTop() {
    const { useBodyScrollTop, scrollTargetSelector } = this.props;
    const scrollTarget = scrollTargetSelector
      ? document.querySelector(scrollTargetSelector)
      : window;
    const scrollTop = useBodyScrollTop ? this.getBodyScrollTop() : scrollTarget.scrollTop;
    return scrollTop;
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  scrollTop(scrollTarget, scrollTop) {
    const { useBodyScrollTop } = this.props;
    if (useBodyScrollTop) {
      document.body.scrollTop = scrollTop;
      document.documentElement.scrollTop = scrollTop;
    } else {
      scrollTarget = scrollTop;
    }
  }

  curryOnClick(index) {
    return () => {
      const { navs } = this.props;
      const selector = navs[index].selector;
      const node = document.querySelector(selector);
      if (node) {
        this.clickActived = true;
        this.scrollIntoView(node);
        this.setState({
          activeNavIndex: index,
        });
      }
    };
  }

  render() {
    const { navs } = this.props;
    const { activeNavIndex } = this.state;
    return (
      <div ref={this.ref} className={styles.wrapper}>
        <ul className={styles.nav}>
          {navs.map((nav, index) => {
            return (
              <li
                key={index}
                className={`${styles.navItem} ${
                  index === activeNavIndex ? 'active theme-border-color' : ''
                } `}
                onClick={this.curryOnClick(index)}
              >
                <span className={styles.title}>{nav.title}</span>
                {!!nav.hasError && <Icon name="info" className={styles.errorIcon} />}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

FormNav.defaultProps = {
  useBodyScrollTop: false,
  offsetTop: 0,
  fixTop: 80,
};

FormNav.propTypes = {
  scrollTargetSelector: PropTypes.string, // 绑定scroll node 的 selector 默认是window
  formSelector: PropTypes.string.isRequired, // 表单的selector
  // 强制使用document.body.scrollTop 作为scrollTop值
  // 主要是为了修复有时候 scroll event trigger 在window上 ，但是document.body.scrollTop才是准确值的bug
  useBodyScrollTop: PropTypes.bool.isRequired,
  offsetTop: PropTypes.number, // 有顶部固定导航时，viewport距离顶部多少
  fixTop: PropTypes.number, // nav fixed时top的值
  navs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      selector: PropTypes.string,
      hasError: PropTypes.bool,
    })
  ),
};

export default FormNav;
